const OTHER_ID = "Other";
const getValueIncludesOther = (value, optionsNames) => value.some((_value) => !optionsNames.includes(_value));
const getIsOtherOptionSelected = (value, optionsNames) => value.length > 0 && getValueIncludesOther(value, optionsNames);
const getOtherLabel = (addOtherLabel, t) => {
  const otherLabelDefault = t?.("add-other.default-other-option-label");
  return addOtherLabel || otherLabelDefault || OTHER_ID;
};
const getOtherValue = (value, addOtherLabel) => {
  const addedSymbolsLength = 2;
  const otherLabelLength = addOtherLabel ? addOtherLabel.length + addedSymbolsLength : 0;
  const otherItem = value.find((item) => item.startsWith(`${addOtherLabel}: `)) || "";
  return otherItem.slice(otherLabelLength);
};
const getOptionsValues = (options) => options.map((option) => option.value ?? option.label);
export {
  OTHER_ID,
  getIsOtherOptionSelected,
  getOptionsValues,
  getOtherLabel,
  getOtherValue
};
//# sourceMappingURL=checkbox-group-field-utils.js.map
